import { render, staticRenderFns } from "./PrimeUpgradeModal.vue?vue&type=template&id=10b68043&scoped=true"
import script from "./PrimeUpgradeModal.vue?vue&type=script&lang=js"
export * from "./PrimeUpgradeModal.vue?vue&type=script&lang=js"
import style0 from "./PrimeUpgradeModal.vue?vue&type=style&index=0&id=10b68043&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b68043",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b68043')) {
      api.createRecord('10b68043', component.options)
    } else {
      api.reload('10b68043', component.options)
    }
    module.hot.accept("./PrimeUpgradeModal.vue?vue&type=template&id=10b68043&scoped=true", function () {
      api.rerender('10b68043', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/setting/pricing/components/PrimeUpgradeModal.vue"
export default component.exports